// Print & Export Utilities for RT 06 RW 01 Menanggal

export function printCitizenCard(citizen, regional, iuranData, year) {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
        alert('Izinkan popup browser untuk mencetak kartu.');
        return;
    }
    const locName = 'Kelurahan Menanggal, Kecamatan Gayungan, Kota Surabaya';
    
    let html = `<!DOCTYPE html>
<html>
<head>
    <meta charset="utf-8" />
    <title>Kartu Warga - ${citizen?.head_of_family || citizen?.name || 'Warga'}</title>
    <style>
        @page { size: A4 portrait; margin: 15mm; }
        body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 10px; color: #1e293b; line-height: 1.5; }
        .header { display: flex; align-items: center; border-bottom: 2px solid #065f46; padding-bottom: 12px; margin-bottom: 20px; }
        .header img { width: 60px; height: 60px; margin-right: 15px; }
        .header-title h2 { margin: 0; font-size: 18px; color: #065f46; text-transform: uppercase; }
        .header-title p { margin: 3px 0 0; font-size: 12px; color: #64748b; }
        .info-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 13px; }
        .info-table td { padding: 8px 6px; border-bottom: 1px solid #e2e8f0; }
        .info-table td.label { font-weight: bold; width: 32%; color: #475569; }
        .footer { margin-top: 40px; display: flex; justify-content: space-between; font-size: 12px; }
        .signature { text-align: center; width: 200px; }
        @media print {
            body { padding: 0; }
            button { display: none; }
        }
    </style>
</head>
<body>
    <div class="header">
        <img src="/logo_surabaya.svg" alt="Logo Pemkot Surabaya" onerror="this.style.display='none'" />
        <div class="header-title">
            <h2>RUKUN TETANGGA 06 / RUKUN WARGA 01</h2>
            <p>${locName}</p>
            <p style="font-weight: bold; color: #0f172a; margin-top: 2px;">KARTU IDENTITAS KELUARGA & WARGA</p>
        </div>
    </div>
    <table class="info-table">
        <tr><td class="label">Nama Kepala Keluarga</td><td>: <strong>${citizen?.head_of_family || citizen?.name || '-'}</strong></td></tr>
        <tr><td class="label">Nomor Kartu Keluarga (KK)</td><td>: ${citizen?.kk_number || '-'}</td></tr>
        <tr><td class="label">Alamat Domisili</td><td>: ${citizen?.address || 'Jl. Menanggal III / V'}</td></tr>
        <tr><td class="label">Status Warga</td><td>: ${citizen?.citizen_type || 'Warga Tetap'}</td></tr>
        <tr><td class="label">Nomor Telepon / HP</td><td>: ${citizen?.phone || '-'}</td></tr>
        <tr><td class="label">Jumlah Anggota Keluarga</td><td>: ${citizen?.family_members_count || 1} Jiwa</td></tr>
        <tr><td class="label">Tahun Periode Data</td><td>: ${year || new Date().getFullYear()}</td></tr>
    </table>
    <div class="footer">
        <div class="signature">
            <p>Warga Bersangkutan,</p>
            <br/><br/><br/>
            <p>( ${citizen?.head_of_family || citizen?.name || 'Warga'} )</p>
        </div>
        <div class="signature">
            <p>Surabaya, ${new Date().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
            <p>Ketua RT 06 Menanggal,</p>
            <br/><br/><br/>
            <p><strong>( Putut N. )</strong></p>
        </div>
    </div>
    <script>
        window.onload = function() { window.print(); };
    </script>
</body>
</html>`;

    printWindow.document.write(html);
    printWindow.document.close();
}

export function printFinancialReport(iuranList = [], expenses = [], report = {}, regional = {}, year = 2026, month = null) {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
        alert('Izinkan popup browser untuk membuka lembar print out laporan keuangan.');
        return;
    }
    const fmt = n => 'Rp ' + Number(n || 0).toLocaleString('id-ID');
    const MONTHS = ['', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];

    const periodLabel = month ? `Bulan ${MONTHS[month]} ${year}` : `Tahun ${year} (Rekapitulasi Penuh)`;

    // Calculate totals & correlation
    const opBal = report?.opening_balance || 0;
    const totalInc = report?.iuran_total || report?.total_income || iuranList.reduce((acc, c) => acc + (c.amount || 0), 0);
    const totalAvail = report?.total_available || (opBal + totalInc);
    const totalExp = report?.expense_total || report?.total_expense || expenses.reduce((acc, c) => acc + (c.amount || 0), 0);
    const endingBal = report?.ending_balance !== undefined ? report.ending_balance : (totalAvail - totalExp);

    let html = `<!DOCTYPE html>
<html>
<head>
    <meta charset="utf-8" />
    <title>Laporan Kas RT 06 Menanggal - ${periodLabel}</title>
    <style>
        @page { size: A4 landscape; margin: 10mm 12mm; }
        body { font-family: 'Segoe UI', Arial, sans-serif; padding: 10px; color: #1e293b; font-size: 11px; line-height: 1.4; }
        .header { display: flex; align-items: center; border-bottom: 2.5px solid #065f46; padding-bottom: 10px; margin-bottom: 12px; }
        .header img { width: 50px; height: 50px; margin-right: 15px; object-fit: contain; }
        .header-title h2 { margin: 0; font-size: 16px; color: #065f46; text-transform: uppercase; letter-spacing: 0.5px; }
        .header-title p { margin: 2px 0 0; font-size: 11px; color: #475569; }
        .period-tag { display: inline-block; background: #e6f4ea; color: #065f46; font-weight: bold; padding: 2px 8px; border-radius: 4px; margin-top: 4px; font-size: 11px; }
        
        .reconciliation-flow { display: flex; align-items: center; justify-content: space-between; gap: 8px; background: #f8fafc; border: 1.5px solid #cbd5e1; border-radius: 8px; padding: 10px 14px; margin-bottom: 14px; }
        .flow-step { text-align: center; flex: 1; }
        .flow-step .lbl { font-size: 9px; text-transform: uppercase; font-weight: 700; color: #64748b; margin-bottom: 3px; }
        .flow-step .num { font-size: 13px; font-weight: 800; }
        .flow-operator { font-size: 16px; font-weight: 900; color: #94a3b8; }
        
        h3 { font-size: 11px; font-weight: 700; color: #0f172a; margin: 14px 0 6px; border-left: 3px solid #065f46; padding-left: 6px; text-transform: uppercase; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 12px; font-size: 10px; }
        th, td { border: 1px solid #cbd5e1; padding: 5px 6px; text-align: left; }
        th { background: #065f46; color: #ffffff; font-weight: 600; text-align: center; }
        .text-right { text-align: right; }
        .text-center { text-align: center; }
        .total-row td { background: #f1f5f9; font-weight: bold; }
        
        .footer { margin-top: 20px; display: flex; justify-content: space-between; font-size: 11px; page-break-inside: avoid; }
        .sig-block { text-align: center; width: 220px; }
        @media print {
            body { padding: 0; }
            .no-print { display: none; }
        }
    </style>
</head>
<body>
    <div class="header">
        <img src="/logo_surabaya.svg" alt="Logo Pemkot Surabaya" onerror="this.style.display='none'" />
        <div class="header-title">
            <h2>RUKUN TETANGGA 06 / RUKUN WARGA 01</h2>
            <p>Kelurahan Menanggal, Kecamatan Gayungan, Kota Surabaya, Jawa Timur 60234</p>
            <div class="period-tag">LAPORAN PEMBUKUAN KAS RESMI &bull; PERIODE ${periodLabel.toUpperCase()} &bull; TOTAL 72 KK</div>
        </div>
    </div>

    <!-- Kotak Rekonsiliasi & Korelasi Saldo Berkesinambungan -->
    <div class="reconciliation-flow">
        <div class="flow-step">
            <div class="lbl">Saldo Awal Kas</div>
            <div class="num" style="color: #475569;">${fmt(opBal)}</div>
        </div>
        <div class="flow-operator">+</div>
        <div class="flow-step">
            <div class="lbl">Pemasukan Iuran</div>
            <div class="num" style="color: #16a34a;">${fmt(totalInc)}</div>
        </div>
        <div class="flow-operator">=</div>
        <div class="flow-step">
            <div class="lbl">Total Kas Tersedia</div>
            <div class="num" style="color: #0284c7;">${fmt(totalAvail)}</div>
        </div>
        <div class="flow-operator">-</div>
        <div class="flow-step">
            <div class="lbl">Pengeluaran Kas</div>
            <div class="num" style="color: #ea580c;">${fmt(totalExp)}</div>
        </div>
        <div class="flow-operator">=</div>
        <div class="flow-step" style="background: #e6f4ea; border-radius: 6px; padding: 4px;">
            <div class="lbl" style="color: #065f46;">Sisa Saldo Kas Akhir</div>
            <div class="num" style="color: ${endingBal >= 0 ? '#065f46' : '#dc2626'};">${fmt(endingBal)}</div>
        </div>
    </div>

    <!-- Tabel Rincian Pengeluaran -->
    <h3>I. Rincian Pengeluaran Kas RT 06 (${expenses.length} Transaksi)</h3>
    <table>
        <thead>
            <tr>
                <th style="width: 25px;">No</th>
                <th style="width: 70px;">Tanggal</th>
                <th style="width: 80px;">Kategori</th>
                <th>Uraian Belanja / Transaksi</th>
                <th style="width: 90px;">Nominal (Rp)</th>
                <th>Catatan / Keterangan</th>
            </tr>
        </thead>
        <tbody>
            ${expenses.length === 0 ? '<tr><td colspan="6" class="text-center">Tidak ada transaksi pengeluaran pada periode ini.</td></tr>' :
                expenses.map((e, idx) => `
                    <tr>
                        <td class="text-center">${idx + 1}</td>
                        <td class="text-center">${e.date || '-'}</td>
                        <td><span style="font-weight: 600;">${e.category || '-'}</span></td>
                        <td>${e.description || e.title || '-'}</td>
                        <td class="text-right" style="font-weight: 600;">${fmt(e.amount)}</td>
                        <td>${e.notes || '-'}</td>
                    </tr>
                `).join('')
            }
            <tr class="total-row">
                <td colspan="4" class="text-center">TOTAL REALISASI PENGELUARAN</td>
                <td class="text-right" style="color: #ea580c;">${fmt(totalExp)}</td>
                <td></td>
            </tr>
        </tbody>
    </table>

    <div class="footer">
        <div class="sig-block">
            <p>Mengetahui,</p>
            <p style="font-weight: bold; margin-top: -8px;">Ketua RT 06 Menanggal</p>
            <br/><br/><br/>
            <p><strong>( Putut N. )</strong></p>
        </div>
        <div class="sig-block">
            <p>Surabaya, ${new Date().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
            <p style="font-weight: bold; margin-top: -8px;">Pengurus Keuangan / Bendahara</p>
            <br/><br/><br/>
            <p><strong>( Pengurus Kas RT 06 )</strong></p>
        </div>
    </div>

    <script>
        window.onload = function() { window.print(); };
    </script>
</body>
</html>`;

    printWindow.document.write(html);
    printWindow.document.close();
}
